import { registerQuery, useQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { listAgentsRpc } from '../../__generated__/chirp/com/hubspot/breeze/engine/rpc/BreezeEngineAgentsService';
import { captureException } from '../utils/sentryUtils';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
const BREEZE_AGENTS_FIELD = 'breezeAgents';
const EMPTY_AGENTS_RECORD = {};

// listAgents uses substring matching (SQL LIKE) on the query param, so we fan
// out one call per agent id and filter the results for an exact agentId match.
// We don't expect more than a couple agent ids here (most likely just 1).
const FETCH_BREEZE_AGENTS = registerQuery({
  fieldName: BREEZE_AGENTS_FIELD,
  args: ['agentIds'],
  fetcher: async ({
    agentIds
  }) => {
    const entries = await Promise.all(agentIds.map(async agentId => {
      try {
        const response = await chirpClient.call(listAgentsRpc, {
          request: {
            query: agentId
          }
        });
        const match = response.results.find(agent => agent.agentId === agentId);
        if (!(match !== null && match !== void 0 && match.displayName)) return null;
        return [agentId, {
          displayName: match.displayName
        }];
      } catch (err) {
        captureException(err, {
          extra: {
            fingerprint: 'useBreezeAgents-listAgents',
            agentId
          }
        });
        return null;
      }
    }));
    const agentsRecord = {};
    for (const entry of entries) {
      if (entry) {
        const [agentId, info] = entry;
        agentsRecord[agentId] = info;
      }
    }
    return agentsRecord;
  }
});
export const useBreezeAgents = ({
  agentIds
}) => {
  var _data$BREEZE_AGENTS_F;
  const {
    data,
    loading
  } = useQuery(FETCH_BREEZE_AGENTS, {
    variables: {
      agentIds: [...agentIds]
    },
    skip: agentIds.length === 0
  });
  return {
    agentsRecord: (_data$BREEZE_AGENTS_F = data === null || data === void 0 ? void 0 : data[BREEZE_AGENTS_FIELD]) !== null && _data$BREEZE_AGENTS_F !== void 0 ? _data$BREEZE_AGENTS_F : EMPTY_AGENTS_RECORD,
    loading
  };
};